var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95632 0.289982L4.31952 3.91019C4.07663 4.15198 3.93877 4.48525 3.93877 4.83158V11.3597C3.93877 12.0785 4.52959 12.6667 5.2517 12.6667H11.1599C11.685 12.6667 12.1577 12.353 12.3678 11.876L14.5078 6.90308C15.0592 5.60921 14.1074 4.17158 12.696 4.17158H8.98697L9.61061 1.1787C9.67625 0.851964 9.57778 0.518696 9.34146 0.283447C8.95415 -0.0955645 8.33707 -0.0955645 7.95632 0.289982ZM1.31292 12.6667C2.03503 12.6667 2.62585 12.0785 2.62585 11.3597V6.13199C2.62585 5.41317 2.03503 4.82505 1.31292 4.82505C0.590816 4.82505 0 5.41317 0 6.13199V11.3597C0 12.0785 0.590816 12.6667 1.31292 12.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.9721693b2ba022abbd2142a1be1f4b96.svg";
export { ForwardRef as ReactComponent };